<template>
  <div class="">
    <Pie :chart-data="chartData" :chart-options="chartOptions" :width="180" :height="130" class="px-10" />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  data() {
    return {
    
    }},

  name: 'PieChart',
  components: { Pie },
  props: {
    data: {
      type: Array,
      required: true,
    },
    legendColor: Object,
    chartOptions:Object,
  },
  

  

  mounted() {
    // Log the data prop to verify it's being passed correctly


  },
  computed: {
    chartData() {
      const colors = this.data.map(item => this.legendColor[item.label] || "#90A4AE");
      return {
        labels: this.data.map(item => item.label),
        datasets: [
          {
            backgroundColor: colors,
            data: this.data.map(item => item.value)
          }
        ]
      }
    },
  },
}
</script>
<style scoped>
.pie-chart {
  max-width: 180px;
  min-width: 120px;
  margin: auto;
}
</style>